module.exports = __webpack_public_path__ + "img/circle.95875b9f.svg";